// extracted by mini-css-extract-plugin
export default {"headCard":"categoriesPage_headCard__6tsTS","cardCustom":"categoriesPage_cardCustom__-Wbzs","cardBodyCustom":"categoriesPage_cardBodyCustom__kSvDj"};